import Vue from "vue";
const fb = require("../../../firebaseConfig.js");

const state = {
    currentUser: null,
    userProfile: {},
    users: {}
};

const actions = {
    clearUserData({ commit }) {
        commit("setCurrentUser", null);
        commit("setUserProfile", {});
    },
    fetchUserProfile: ({ commit, state }) => {
        fb.usersCollection
            .doc(state.currentUser.uid)
            .get()
            .then(res => {
                commit("setUserProfile", res.data());
            })
            .catch(error => {
                console.log(error);
            });
    }
};

const mutations = {
    setCurrentUser(state, val) {
        state.currentUser = val;
    },
    setUserProfile(state, val) {
        state.userProfile = val;
        console.log(state.userProfile);
    }
};

const getters = {
    getCurrentUser(state) {
        return state.currentUser;
    },
    getUserProfile(state) {
        return state.userProfile;
    },
    getUsers: state => {
        return state.users;
    }
};

export default {
    state,
    actions,
    getters,
    mutations
};